import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withStyles, Typography, Button } from '@material-ui/core';
import { POI_ACTION_TYPES } from '../../redux-saga/actionTypes';
import styles from './styles';

const Price = ({ classes, t, filterListEvent, criteriaList }) => {
  const selectedButton = classes.any__button;
  const notSelectedButton = classes.price__button;
  const anyText = classes.any__text;
  const price = classes.price__text;
  const [selectedValue, setSelectedValue] = React.useState(criteriaList.price);

  const handleSelectedIndex = value => {
    setSelectedValue(value);
    filterListEvent({ criteriaName: 'price', value });
  };

  const list = [
    { symbol: t('filter.label.action-button.any'), price: '*' },
    { symbol: t('filter.label.1dollar'), price: '$' },
    { symbol: t('filter.label.2dollar'), price: '$$' },
    { symbol: t('filter.label.3dollar'), price: '$$$' },
    { symbol: t('filter.label.4dollar'), price: '$$$$' },
  ];

  return (
    <React.Fragment>
      <span className={classes.container}>
        <span className={classes.title__wrapper}>
          <Typography className={classes.title}>{t('filter.label.price')}</Typography>
        </span>
        <span className={classes.scroll__wheel}>
          {list.map(value => (
            <Button
              value={selectedValue}
              onClick={() => handleSelectedIndex(value.price)}
              className={selectedValue === value.price ? selectedButton : notSelectedButton}
            >
              <Typography className={selectedValue === value.price ? anyText : price}>
                {value.symbol}
              </Typography>
            </Button>
          ))}
        </span>
      </span>
    </React.Fragment>
  );
};

Price.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  filterListEvent: PropTypes.func.isRequired,
  criteriaList: PropTypes.object,
};

Price.defaultProps = {
  criteriaList: { price: '*' },
};

const mapStateToProps = ({ poi }) => ({
  criteriaList: poi.filter_criteria_list,
});

const mapDispatchToProps = dispatch => ({
  filterListEvent: payload => dispatch({ type: POI_ACTION_TYPES.FILTER.SET, payload }),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(Price)),
);
